/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.InventoryCount {
    angular.module("meevo.plugins.inventoryCount", []);
}